const skeletonClasses = 'bg-ds-natural-150 rounded-sm h-2 animate-pulse';

export const StatsCardItemSkeleton = () => {
  return (
    <div className="flex justify-between items-center h-20 p-6">
      <div className="flex flex-col gap-3">
        <div className={`${skeletonClasses} w-14`} />
        <div className={`${skeletonClasses} w-20`} />
      </div>
      <div className={`${skeletonClasses} w-14`} />
    </div>
  );
};
